import ComponentMixin from '../smart/component.m.js';

class Base extends HTMLElement {
    constructor(...args) {
        super(...args);
    }
}

export default class Tag extends ComponentMixin(Base) {
    constructor(...args) {
        // Constructor caveat https://github.com/WebReflection/document-register-element/
        const _ = super(...args);
        return _;
    }

    setup() {
        super.setup();

        this.on(['click', 'keyup']);
        this.syncProp('dismissable');
        this.syncProp('nonclickable');
        this.syncProp('value');
        this.syncProp('active');
    }

    static get observedAttributes() {
        return super.observedAttributes.concat(['value', 'dismissable', 'nonclickable', 'active']);
    }

    get dismissableElement() {
        if (!this.dismissable) {return;};
        this._dismissableEle = this.querySelector('[close]');

        if (!this._dismissableEle) {
            this._dismissableEle = document.createElement('a');
            this._dismissableEle.classList.add('zs-icon');
            this._dismissableEle.classList.add('zs-icon-remove');
            this._dismissableEle.setAttribute('close', '');
            this.appendChild(this._dismissableEle);
        }

        return this._dismissableEle;
    }

    set dismissableElement(ele) {
        if (ele == null) {
            this._dismissableEle.parentNode.removeChild(this._dismissableEle);
        }
        this._dismissableEle = ele;
    }

    attributeChangedCallback(name, oldValue, newValue) {
        super.attributeChangedCallback(name, oldValue, newValue);

        switch (name) {
            case 'dismissable':
            case 'nonclickable':
            case 'active':
                this.syncAttr(name, newValue, 'boolean');
                break;
            default:
                this.syncAttr(name, newValue, 'string');
        }
    }

    propertyChangedCallback(name, oldValue, newValue) {
        if (!this._isRendered) { return; }
        if (name == 'dismissable') {
            if (newValue) {
                this.render();
            } else {
                this.dismissableElement = null;
            }
        }
        if (name == 'nonclickable') {
            if (newValue) {
                this.removeAttribute('tabindex');
                this.removeAttribute('role'); //For accessibility
            } else {
                this.render();
            }
        }
    }

    connectedCallback() {
        super.connectedCallback();
        window.requestAnimationFrame(() => {
            this.render();
        });
    }

    render() {
        if (this.dismissableElement) {
            this.dismissableElement.setAttribute('href', '#');
            this.dismissableElement.setAttribute('onclick','return false;');
        }
        if (!this.nonclickable) {
            this.setAttribute('tabindex', '0');
            this.setAttribute('role', 'button'); //For accessibility
        }
        this._isRendered = true;
    }

    onclick(e) {
        if (this.dismissableElement && this.dismissableElement.contains(e.target)) {
            this.parentElement.removeChild(this);
        }
    }

    onkeyup(e) {
        if (e.keyCode == 32 || e.keyCode == 13) {
            this.onclick(e);
        }
    }
}

Tag.is = 'zs-tag';